<template>
  <div class="container has-text-left">
    <div class="section pt-0">
      <div class="columns is-mobile is-multiline">
        <div class="column is-full">
          <h2 class="is-size-5 has-text-weight-bold">{{ this.$i18n.t('general.CONFIGURATOR') }}</h2>
          <p>{{ this.$i18n.t('general.SelectAnOption') }}.</p>
        </div>
        <div class="column is-full">
          <ul>
            <li v-for="(puente,i) in puentes" :key="'puente_'+puente.sku">
              <div>
                <div class="foto">
                  <a href="javascript:;" class="nombre is-size-5">{{ puente["nombre-completo"][$i18n.locale.replace('_','-').toLowerCase()] }}</a>
                  <a href="javascript:;" @click="selPuente(puente.sku)" class="plus has-text-right is-size-6">
                        <span class="has-text-centered"><img svg-inline class="icon" src="../assets/img/icon-plus.svg"
                                                             :alt="$i18n.t('general.select')"/></span>
                  </a>
                  <b-carousel
                      :interval=6000
                      repeat
                      has-drag
                      animated="slide"
                      :autoplay=false
                  >
                    <b-carousel-item v-for="(foto,j) in puente.fotosgal" :key="'foto_'+puente.sku+i+'_'+j">
                      <div class="hero">
                        <div class="hero-body p-0 has-text-centered">
                          <img
                              :src="require('@/assets/img/' + foto.path)"
                              :alt="foto.alt"
                          >
                        </div>
                      </div>
                    </b-carousel-item>
                  </b-carousel>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'listaPuentes',
  data(){

    return {
      puentes: null,
    }
  },
  mounted: function () {
    this.puentes = this.$store.getters.getPuentes


  },
  methods: {
    selPuente(sku){


      if (!this.$store.getters.getSKUActivo.includes(sku)){
        this.$store.commit('setConfigHash',null)
        this.$store.dispatch('getConfigPuenteFromBackend', sku)
        this.$store.commit('setIsMenuModalActive',false)
      }

      this.$router.replace( '/'+this.$route.params.pais+'/'+this.$i18n.locale+'/'+sku)




      this.$store.commit('setIsMenuModalActive',false)

      //this.parent.isMenuModalActive = false

    }
  }
}
</script>
